






































import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { TerminalPayload } from '@/store/Mobile/state';

import formatter from '@/mixins/formatter';
import ImageMixin from '@/mixins/image';

import GrayLabel from '@/components/Atoms/Label/Gray.vue';
import OrangeLabel from '@/components/Atoms/Label/Orange.vue';
import RedLabel from '@/components/Atoms/Label/Red.vue';
import Price from '@/components/Atoms/Text/Price.vue';
import Number from '@/components/Atoms/Input/Number.vue';

import ProductCount from '@/components/Molecules/Input/ProductCount.vue';
import Card from '@/components/Atoms/ListItem/Card.vue';

@Component({
  components: {
    Card,
    GrayLabel,
    RedLabel,
    OrangeLabel,
    Price,
    Number,
    ProductCount,
  },
})
export default class Terminal extends mixins(formatter, ImageMixin) {
  @Prop() private item!: any;
  @Prop() private index!: number;
  @Prop() planTotal!: number;
  @Prop() terminalTotal!: number;
  @Prop() hasError!: boolean;
  private namespace = 'mobile';
  count = 0;

  labelComponent(carrier: string): any {
    return carrier == 'docomo' ? RedLabel : OrangeLabel;
  }

  get payload(): TerminalPayload {
    return { stateKey: 'terminals', id: this.item.id };
  }

  get selected(): boolean {
    return this.count > 0;
  }

  get maxValue(): number {
    const margin = this.planTotal - this.terminalTotal;
    return margin < 0 ? 0 : this.count + margin;
  }

  updateCount(count: number) {
    this.count = count;
  }
}
